
import React from 'react';
import { X, BookOpen } from 'lucide-react';

const HelpModal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
            <div className="bg-white dark:bg-gray-800 w-full max-w-sm rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[80vh] animate-scale-up relative border border-gray-100 dark:border-gray-700">

                {/* Header */}
                <div className="p-5 bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-between shrink-0">
                    <div className="flex items-center gap-3 text-white">
                        <div className="bg-white/20 p-2 rounded-xl">
                            <BookOpen size={20} />
                        </div>
                        <h2 className="text-lg font-bold">Guia de Ajuda</h2>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 overflow-y-auto custom-scrollbar">
                    <h3 className="text-lg font-bold text-gray-800 dark:text-white mb-4 flex items-center gap-2">
                        {title}
                    </h3>
                    <div className="prose prose-sm dark:prose-invert text-gray-600 dark:text-gray-300 leading-relaxed space-y-3">
                        {children}
                    </div>
                </div>

                <div className="p-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
                    <button
                        onClick={onClose}
                        className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl transition-colors shadow-lg shadow-indigo-200 dark:shadow-none"
                    >
                        Entendi
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HelpModal;
